import * as React from 'react';
import { colors } from '@app/components/designTokens';

/** Compact role chips. ROLE_ADMIN is highlighted; the "ROLE_" prefix is stripped. */
export const RoleChips: React.FunctionComponent<{ roles: string[] }> = ({ roles }) => {
  if (!roles || roles.length === 0) return <span style={{ color: colors.placeholder }}>—</span>;
  return (
    <span style={{ display: 'inline-flex', flexWrap: 'wrap', gap: 4 }}>
      {roles.map(r => {
        const admin = r === 'ROLE_ADMIN';
        return (
          <span
            key={r}
            style={{
              fontSize: 11,
              fontWeight: 700,
              padding: '2px 8px',
              borderRadius: 9999,
              background: admin ? 'rgba(99, 102, 241, 0.14)' : colors.bgMuted,
              color: admin ? colors.accent : colors.muted,
              whiteSpace: 'nowrap'
            }}
          >
            {r.replace(/^ROLE_/, '')}
          </span>
        );
      })}
    </span>
  );
};
